import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiRoutes } from 'consts';
import { apiErrorHandler } from 'services/apiErrorHandler';
import { showErrorNotification } from 'utils/notification';
import { ThunkConfig } from 'app/providers/StoreProvider';
import { getOrderDashboardDates } from '../selectors/orderDashboardSelectors';

// Предположим, что тип данных запасов — StockData
// Нужно определить этот тип в соответствии с тем, что возвращает твой API
type StockData = any; // Замените any на реальный тип данных

export const getOrdersStats = createAsyncThunk<
  StockData | undefined,
  void,
  ThunkConfig<string>
>('stock/getOrdersStats', async (_, thunkApi) => {
  const {
    extra: { api },
    getState,
  } = thunkApi;
  try {
    const { dateFrom, dateTo } = getOrderDashboardDates(getState());
    const { data } = await api.get(ApiRoutes.OrdersDashboard, {
      params: { dateFrom, dateTo },
    });    

    return data;
  } catch (error) {
    const { message } = apiErrorHandler(error);
    showErrorNotification([message]);
    // Важно возвращать явно undefined, если функция должна завершиться после ошибки
    return undefined;
  }
});
